var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.tileClass,attrs:{"draggable":_vm.draggable},on:{"dragstart":_vm.dragstart,"dragend":_vm.dragend,"click":_vm.openLetterSelection,"dblclick":_vm.moveToDraw}},[_c('span',[_vm._v(_vm._s(_vm.droppedTile.value)),_c('span',{staticClass:"points"},[_vm._v(_vm._s(_vm.droppedTile.tile.point))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e549384","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/games/Tile.vue
// module id = null
// module chunks = 